import{createContext}from"react";export const QueryBuilderContext=/*#__PURE__*/createContext({});